import { Component, OnInit, inject, signal, ViewEncapsulation } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Router, ActivatedRoute, RouterLink } from "@angular/router";
import { MessageService, ConfirmationService, SelectItem, PrimeTemplate } from "primeng/api";
import { Observable, of } from "rxjs";
import {
  LEVEL_PUBLISHED,
  NUMBER_LIST,
  PARAM_PAGES_PATH,
  ROOM_TYPE_LIST,
  STATE_LIST,
  STATE_PAGES_PUBLISHED,
  STATUS_ROOMS,
  TEMPLATE_PUBLISHED,
  TYPE_LIST,
} from "src/app/constants/constants";
import { AbstractFormComponent } from "../../common/abstract-edit.component";
import { Rooms } from "src/app/models/rooms";
import { CategoryService } from "src/app/services/categories.service";
import { RoomsService } from "src/app/services/rooms.service";
import { Technical_data } from "src/app/models/technical_data";
import { TechnicalDataService } from "src/app/services/technical_data.service";
import { Category } from "src/app/models/category";
import { Works } from "src/app/models/works";
import { WorksService } from "src/app/services/works.service";
import { TopNavComponent } from "../../top-nav/top-nav.component";
import { Bind } from "primeng/bind";
import { ButtonDirective } from "primeng/button";
import { Tabs, TabList, Tab, TabPanels, TabPanel } from "primeng/tabs";
import { Ripple } from "primeng/ripple";
import { Card } from "primeng/card";
import { SelectButton } from "primeng/selectbutton";
import { InputText } from "primeng/inputtext";
import { Select } from "primeng/select";
import { Textarea } from "primeng/textarea";

import { UploadComponent } from "../../components/upload/upload.component";
import { InputNumber } from "primeng/inputnumber";
import { ConfirmDialog } from "primeng/confirmdialog";
import { Toast } from "primeng/toast";
import { TranslatePipe } from "@ngx-translate/core";

import { TPipe } from "../../i18n/t.pipe";
@Component({
    standalone: true,
    selector: "app-rooms-form",
    templateUrl: "./rooms-form.component.html",
    styleUrl: "./rooms-form.component.less",
    encapsulation: ViewEncapsulation.None,
    imports: [TPipe, TopNavComponent, FormsModule, ReactiveFormsModule, Bind, ButtonDirective, RouterLink, Tabs, TabList, Ripple, Tab, TabPanels, TabPanel, Card, SelectButton, InputText, Select, PrimeTemplate, Textarea, UploadComponent, InputNumber, ConfirmDialog, Toast, TranslatePipe]
})
export class RoomsFormComponent
  extends AbstractFormComponent<Rooms>
  implements OnInit
{
  protected fb: FormBuilder;
  private roomsService = inject(RoomsService);
  private worksService = inject(WorksService);
  private technicalDataService = inject(TechnicalDataService);
  private categoryService = inject(CategoryService);

  pageTitle: string;
  form: FormGroup;
  idField = "id";
  formFields = [
    "id",
    "title",
    "category_id",
    "description",
    "description_full",
    "status",
    "max_adults",
    "max_children",
    "max_capacity",
    "is_active",
    "base_persons",
    "children_ranges",
    "floors",
    "mq",
    "code",
    "price_base",
    "bathrooms",
    "is_featured",
    "price_extra_adult",
    "price_single",
    "skills",
  ];

  item$: Observable<Rooms> = of();
  readonly stateOptions = signal(STATE_LIST);
  service = this.roomsService;
  readonly element = signal<Rooms>(undefined);
  selectedStatePublished: SelectItem[] = [];
  selectedTemplatePublished: SelectItem[] = [];
  selectedLevelPublished: SelectItem[] = [];
  statePublished = STATE_PAGES_PUBLISHED;
  readonly levelPublished = signal<any[]>(undefined);
  selectedPagesPublished: Rooms[];
  rooms: Rooms[] = [];
  readonly templatePublished = signal<any[]>(undefined);
  readonly skillsValues = signal<any | undefined>(undefined);
  readonly rangeValues = signal<any | undefined>(undefined);
  readonly technical_datas = signal<Technical_data[]>(undefined);
  technical_data: Technical_data;
  readonly categories = signal<Category[]>(undefined);
  category: Category;
  selectedWorks: SelectItem[] = [];
  selectedSkills: SelectItem[] = [];
  selectedWorks2: SelectItem[];
  selectedCategories: SelectItem[] = [];
  readonly typeList = signal<any[]>(undefined);
  readonly numberList = signal<any[]>(undefined);
  readonly roomTypeList = signal<any[]>(undefined);
  readonly status = signal<any[]>(undefined);
  readonly works = signal<Works[]>(undefined);

  constructor() {
    const fb = inject(FormBuilder);
    const messageService = inject(MessageService);
    const confirmationService = inject(ConfirmationService);
    const router = inject(Router);
    const route = inject(ActivatedRoute);

    super(
      fb,
      messageService,
      confirmationService,
      router,
      route,
      PARAM_PAGES_PATH,
    );
    this.fb = fb;

    this.stateOptions.set(STATE_LIST);
    this.typeList.set(TYPE_LIST);
    this.numberList.set(NUMBER_LIST);
    this.roomTypeList.set(ROOM_TYPE_LIST);
    this.status.set(STATUS_ROOMS);
  }

  ngOnInit() {
    this.initializeForm();

    const id = this.route.snapshot.paramMap.get("id");
    if (id) {
      this.pageTitle = "Modifica Camera";
      this.loadItem(id);
    } else {
      this.pageTitle = "Aggiungi Camera";
    }

    this.templatePublished.set(TEMPLATE_PUBLISHED);
    this.levelPublished.set(LEVEL_PUBLISHED);

    this.loadTechnicalData();
    this.loadCategories();
    this.loadWorks();
  }

  private loadTechnicalData() {
    const paramsTechnical = [];

    this.technicalDataService.list(paramsTechnical).subscribe((pData) => {
      this.technical_datas.set(pData);
      (error) => (this.error = error);
    });
  }

  private loadWorks() {
    const paramsWorks = [];
    this.worksService.list(paramsWorks).subscribe((pData) => {
      this.works.set(pData);
      (error) => (this.error = error);
    });
  }

  private loadCategories() {
    const paramsCategories = [];
    this.categoryService.list(paramsCategories).subscribe((pData) => {
      this.categories.set(pData);
      (error) => (this.error = error);
    });
  }

  initSkill() {

    const formArray = this.fb.array<FormGroup>([]);

    const id = this.route.snapshot.paramMap.get("id");

    const findParam = {
      field: "skills",
    };

    this.roomsService.find(id, findParam).subscribe((res) => {
      this.skillsValues.set(res);

      this.skillsValues().forEach((e) => {
        formArray.push(
          this.fb.group({
            qty: [e.qty],
            price: [e.price],
          }),
        );
      });
    });

    return formArray;
  }

  initRange() {
    const formArray = this.fb.array<FormGroup>([]);

    const id = this.route.snapshot.paramMap.get("id");

    const findParam = {
      field: "children_ranges",
    };

    this.roomsService.find(id, findParam).subscribe((res) => {
      this.rangeValues.set(res);

      this.rangeValues().forEach((e) => {
        formArray.push(
          this.fb.group({
            min: [e.min],
            max: [e.max],
            price: [e.price],
          }),
        );
      });
    });

    return formArray;
  }

  private createSkillFormGroup(skill: any): FormGroup {
    return new FormGroup({
      qty: new FormControl(skill.qty),
      price: new FormControl(skill.price),
    });
  }

  public addSkill(skill: any) {
    this.skills.push(this.createSkillFormGroup(skill));
  }

  get range(): FormArray {
    return this.form.get("children_ranges") as FormArray;
  }

  get skills(): FormArray {
    return this.form.get("skills") as FormArray;
  }

  newQuantity(): FormGroup {
    return this.fb.group({
      qty: "",
      price: "",
    });
  }

  addQuantity() {
    this.skills.push(this.newQuantity());
  }

  addRange() {
    this.range.push(this.newRange());
  }

  newRange(): FormGroup {
    return this.fb.group({
      min: "",
      max: "",
      price: "",
    });
  }

  removeQuantity(i: number) {
    this.skills.removeAt(i);
  }

  removeRange(i: number) {
    this.range.removeAt(i);
  }

  applyStandardRanges() {
    [[0, 2, 0], [3, 11, 20], [12, 17, 35]].forEach(([min, max, price]) =>
      this.range.push(this.fb.group({ min: [min], max: [max], price: [price] })),
    );
  }

  private bands(): { min: number; max: number; price: number }[] {
    return this.range.controls
      .map((c) => ({
        min: Number(c.get("min")?.value),
        max: Number(c.get("max")?.value),
        price: Number(c.get("price")?.value ?? 0),
        filled: c.get("min")?.value !== null && c.get("min")?.value !== "" && c.get("max")?.value !== null && c.get("max")?.value !== "",
      }))
      .filter((b) => b.filled)
      .sort((a, b) => a.min - b.min);
  }

  rangeSummary(): { label: string; price: string; free: boolean }[] {
    return this.bands().map((b) => ({
      label: b.min === b.max ? `${b.min} anni ` : `${b.min}-${b.max} anni `,
      price: b.price > 0 ? ` ${b.price.toLocaleString("it-IT", { style: "currency", currency: "EUR" })}` : " gratis",
      free: !(b.price > 0),
    }));
  }

  rangeIssues(): string[] {
    const issues: string[] = [];
    const bands = this.bands();
    bands.forEach((b) => {
      if (b.min > b.max) issues.push(`La fascia ${b.min}-${b.max} finisce prima di iniziare.`);
    });
    const ok = bands.filter((b) => b.min <= b.max);
    for (let i = 1; i < ok.length; i++) {
      if (ok[i].min <= ok[i - 1].max) {
        issues.push(`Le fasce ${ok[i - 1].min}-${ok[i - 1].max} e ${ok[i].min}-${ok[i].max} si sovrappongono: conta la prima.`);
      } else if (ok[i].min > ok[i - 1].max + 1) {
        issues.push(`Le età da ${ok[i - 1].max + 1} a ${ok[i].min - 1} non sono in nessuna fascia: quei bambini non pagano.`);
      }
    }
    const maxAge = ok.length ? Math.max(...ok.map((b) => b.max)) : 0;
    const maxChildren = Number(this.form.get("max_children")?.value);
    if (ok.length && ok[0].min > 0) issues.push(`I bambini da 0 a ${ok[0].min - 1} anni non sono in nessuna fascia: non pagano.`);
    if (ok.length && maxAge < 17 && maxChildren > 0) issues.push(`Dopo i ${maxAge} anni nessuna fascia: i bambini più grandi non pagano.`);
    return issues;
  }

  initializeForm() {
    this.form = this.fb.group({
      id: [""],
      title: ["", Validators.required],
      description: [""],
      description_full: [""],
      is_featured: ["0"],
      category_id: [""],
      status: [""],
      max_adults: [""],
      max_children: [""],
      base_persons: [""],
      max_capacity: [""],
      floors: [""],
      bathrooms: [""],
      mq: [""],
      is_active: ["0"],
      image: [""],
      code: [""],
      type_id: [""],
      price_base: [""],
      price_extra_adult: [""],
      price_single: [""],
      children_ranges: this.initRange(),
      skills: this.initSkill(),
    });
  }

  loadItem(id: string) {
    this.service.getId(id).subscribe(
      (res) => {
        this.element.set(res);
        this.form.patchValue({
          title: res.title,
          description: res.description,
          description_full: res.description_full,
          category_id: res.category_id,
          status: res.status,
          base_persons: res.base_persons,
          max_adults: res.max_adults,
          max_children: res.max_children,
          floors: res.floors,
          bathrooms: res.bathrooms,
          is_featured: res.is_featured,
          is_active: res.is_active,
          code: res.code,
          max_capacity: res.max_capacity,
          type_id: res.type_id,
          mq: res.mq,
          price_base: res.price_base,
          price_extra_adult: res.price_extra_adult,
          price_single: res.price_single,
          id: res.id,
          data: res.data,
        });
        // the age bands and the extra data rows are filled by initRange() / initSkill() when the form is built
      },
      (error) => (this.error = error),
    );
  }
}
